export const userTableHeaders = [
  {
    text: "User Name",
    align: "left",
    sortable: true,
    value: "node.userName"
  },
  { text: "User Email", value: "node.userEmail" },
  { text: "Gender", value: "node.gender" },
  { text: "CreateDate", value: "node.createDate" },
  { text: "Birth Date", value: "node.birthDate" },
  { text: "Country", value: "node.country" },
  { text: "State", value: "node.state" },
  { text: "Language", value: "node.language" },
  { text: "Role", value: "node.role" },
  { text: "User Id", value: "node.userId" },
  { text: "Actions", value: "action", sortable: false }
];

export const userDefaultData = {
  userName: "",
  userEmail: "",
  gender: "",
  birthDate: "",
  country: "",
  state: "",
  language: "",
  role: ""
};
